import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const Versiones = WithErrorBoundary(
  'Maestro',
  'Error en Lista de Versiones',
  React.lazy(() => import('./Versiones')),
)
const Concesionarios = WithErrorBoundary(
  'Maestro',
  'Error en Lista de Concesionarios',
  React.lazy(() => import('./Concesionarios')),
)
const Sucursales = WithErrorBoundary(
  'Maestro',
  'Error en Lista de Sucursales',
  React.lazy(() => import('./Sucursales')),
)
const UbicacionesFisicas = WithErrorBoundary(
  'Maestro',
  'Error en Lista de Ubicaciones Físicas',
  React.lazy(() => import('./UbicacionesFisicas')),
)
const UnidadesDeNegocio = WithErrorBoundary(
  'Maestro',
  'Error en Lista de Unidades De Negocio',
  React.lazy(() => import('./UnidadesDeNegocio')),
)
const Lista = WithErrorBoundary(
  'Maestro',
  'Error en Lista de Maestro',
  React.lazy(() => import('./ListaMaestroView')),
)
const FormularioDataMaster = WithErrorBoundary(
  'Maestro',
  'Error en Formulario de Maestro',
  React.lazy(() => import('./FormularioDataMaster')),
)
const Marcas = WithErrorBoundary(
  'Maestro',
  'Error en ABM Marca',
  React.lazy(() => import('./Marcas')),
)
const Modelos = WithErrorBoundary(
  'Maestro',
  'Error en ABM Modelos',
  React.lazy(() => import('./Modelos')),
)
const Empresas = WithErrorBoundary(
  'Maestro',
  'Error en ABM Empresas',
  React.lazy(() => import('./Empresas/Empresas')),
)
const Legales = WithErrorBoundary(
  'Maestro',
  'Error en ABM Legales',
  React.lazy(() => import('./Legales')),
)
const CuentasBancarias = WithErrorBoundary(
  'Maestro',
  'Error en ABM CuentasBancarias',
  React.lazy(() => import('./CuentasBancarias')),
)


const TiposDeCambio = WithErrorBoundary(
  'Maestro',
  'Error en ABM Tipos de cambio',
  React.lazy(() => import('./TiposDeCambio/TiposDeCambio')),
)

const EntidadOtorgante = WithErrorBoundary(
  'Maestro',
  'Error en ABM entidad otorgante',
  React.lazy(() => import('./EntidadOtorgante')),
)

const MonthlyCommissions = WithErrorBoundary(
  'Maestro',
  'Error en lista de meses comisionales',
  React.lazy(() => import('./../commissions/MonthlyCommissions/MonthlyCommissions.store')),
)

/* const PricesUpdateProcesses = WithErrorBoundary(
  'Maestro',
  'Error en Formulario de Maestro',
  React.lazy(() => import('./PricesUpdateProcesses')),
) */

const Precios = WithErrorBoundary(
  'Maestro',
  'Error en Formulario de Maestro',
  React.lazy(() => import('./Precios/Precios')),
)

const PreciosBorrador = WithErrorBoundary(
  'Maestro',
  'Error en borrador de precios',
  React.lazy(() => import('./Precios/Draft/PricesDraft'))
)

const ModelPriceDetails = WithErrorBoundary(
  'Maestro',
  'Error en Formulario de Maestro',
  React.lazy(() => import('./Precios/Details/ModelPriceDetails')),
)

const IndexUpdate = WithErrorBoundary(
  'Maestro',
  'Error en índice de actualización',
  React.lazy(() => import('./IndiceActualizacion/IndiceActualizacion.js'))
)

export const maestroDatos = {
  path: '/maestro-datos',
  name: 'Maestro',
  childRoutes: [
    { path: '', name: 'Maestro', component: Lista, isIndex: true },
    { path: 'crear/', name: 'crear', component: FormularioDataMaster },
    { path: 'crear/:id', name: 'duplicar', component: FormularioDataMaster },
    { path: 'editar/:id', name: 'editar', component: FormularioDataMaster },
    { path: 'ver/:id', name: 'ver', component: FormularioDataMaster },
    { path: 'marcas', name: 'Marcas', component: Marcas },
    { path: 'modelos', name: 'Modelos', component: Modelos },
    { path: 'versiones', name: 'Versiones', component: Versiones },
    { path: 'precios', name: 'Precios', component: Precios },
    { path: 'precios/ver/:modelId', name: 'Detalles', component: ModelPriceDetails },
    { path: 'precios/borrador', name: 'Borrador', component: PreciosBorrador},
    //{ path: 'PricesUpdateProcesses', name: 'Precios', component: PricesUpdateProcesses },
  ],
}

export const gestionDatos = {
  path: '/gestión-datos',
  name: 'Gestion de datos',
  childRoutes: [
    { path: 'concesionarios', name: 'Concesionarios', component: Concesionarios, acronym: 'CNC' },
    { path: 'sucursales', name: 'Sucursales', component: Sucursales },
    { path: 'ubicaciones-fisicas', name: 'Ubicaciones fisicas', component: UbicacionesFisicas },
    { path: 'unidades-de-negocio', name: 'Unidades de negocio', component: UnidadesDeNegocio },
    { path: 'legales', name: 'Legales', component: Legales },
    { path: 'cuentas-bancarias', name: 'Cuentas bancarias', component: CuentasBancarias },
    { path: 'tipos-de-cambio', name: 'Tipos de cambio', component: TiposDeCambio },
    { path: 'entidad-otorgante', name: 'Entidad otorgante', component: EntidadOtorgante },
    { path: 'meses-comisionales', name: 'Meses comisionales', component: MonthlyCommissions },
    { path: 'índice-de-actualización', name: 'Índice de actualizacion', component: IndexUpdate },
  ],
}
export const gestionCuentas = {
  path: '/gestión-cuentas',
  name: 'Gestion de cuentas Empresa',
  childRoutes: [
    { path: 'empresas', name: 'Empresas', component: Empresas },
  ],
}
